<template>
  <div>
    <amplify-authenticator username-alias="email" initial-auth-state="signup">
        <amplify-sign-up
            slot="sign-up"
            username-alias="email"
            :form-fields.prop="formFields"
            :handleAuthStateChange="handleAuthStateChange"
        ></amplify-sign-up>
    </amplify-authenticator>
  </div>
</template>

<script>

export default {
  name: "signup",
  components: {
    // AmplifyAuthenticator
  },
  data() {
    return {
      authState: undefined,
      formFields: [
        {
          type: 'email',
          label: 'Email Address *',
          placeholder: 'Email',
          required: true,
        },
        {
          type: 'password',
          label: 'Password *',
          placeholder: 'Password (minimum 6 character)',
          required: true,
        },
        {
          type: 'given_name',
          label: 'First Name *',
          placeholder: 'First Name',
          required: true,
        },
        {
          type: 'family_name',
          label: 'Last Name *',
          value: this.result,
          placeholder: 'Last Name',
          required: false,
        },
        {
          type: 'phone_number',
          label: 'Mobile Number',
          placeholder: 'Mobile Number',
          required: false,
        },
      ]
    }
  },
  computed : {
    result () {
      let resString = localStorage.getItem('eopp-results');

      if (resString) {
        let result = JSON.parse(resString);
        console.log(result)
        return result;
      } else {
        return {}
      }
    }
  },
  methods : {
    handleAuthStateChange : function (nextAuthState) {
      console.log(nextAuthState);
      // console.log(data);
    }
  }
}
</script>

<style scoped>

</style>
